module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_7016.78991c17.png";